// Handler global que captura crashes que escapariam do ErrorBoundary do React:
//  - window.onerror → erros de scripts síncronos (ex: JSON.parse malformado)
//  - window.onunhandledrejection → Promise rejeitada sem .catch (ex: fetch com CORS)
//
// Todos os erros são enviados pra /api/mobile-logs (sem auth — funciona antes do login).
// Rate-limit local: no máximo 1 evento por segundo pra evitar loop de logs sobre logs.

let lastSentAt = 0;
const MIN_INTERVAL_MS = 1000;

async function sendMobileLog(payload) {
  const nowMs = Date.now();
  if (nowMs - lastSentAt < MIN_INTERVAL_MS) return;   // debounce
  lastSentAt = nowMs;
  try {
    // Import dinâmico pra não criar dependência cíclica com api.js
    const { APP_VERSION } = await import("./version.js");
    const body = {
      device: navigator.userAgent,
      app_version: APP_VERSION,
      screen: window.location.pathname + window.location.search,
      ...payload,
    };
    // Usa fetch direto (não axios) pra evitar interceptors que poderiam disparar novos erros
    const base = process.env.REACT_APP_BACKEND_URL || "";
    await fetch(`${base}/api/mobile-logs`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
  } catch { /* swallow: nunca deixar log-de-erro virar erro */ }
}

export function installGlobalErrorHandlers() {
  // Evita instalar 2x (hot reload + StrictMode)
  if (window.__mobile_logs_installed) return;
  window.__mobile_logs_installed = true;

  window.addEventListener("error", (event) => {
    sendMobileLog({
      kind: "window_error",
      message: event.message || "Uncaught error",
      stack: event.error?.stack || null,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    sendMobileLog({
      kind: "unhandled_rejection",
      message: reason?.message || String(reason || "Unhandled rejection"),
      stack: reason?.stack || null,
    });
  });
}

// Exportado pra ErrorBoundary chamar direto (evita depender de window.onerror que só
// pega erros síncronos — erros de render do React são capturados pelo componentDidCatch).
export function reportBoundaryError(error, componentStack) {
  sendMobileLog({
    kind: "error_boundary",
    message: error?.message || "React render error",
    stack: (error?.stack || "") + "\n---componentStack---\n" + (componentStack || ""),
  });
}
